{
  "add_innovations.cancel_cta": "Cancelar",
  "add_innovations.do_not_overwrite": "(La primera línea del archivo no debe ser editada)",
  "add_innovations.download_example": "Descargar un ejemplo de archivo CSV",
  "add_innovations.ean_fields": "EAN",
  "add_innovations.import_button": "Importar una lista (.csv)",
  "add_innovations.save_button": "Salvar estas innovaciones",
  "add_innovations.search_placeholder": "Escriba al menos 4 letras para filtrar los resultados",
  "add_innovations.success_toaster": "Sus innovaciones se han añadido correctamente",
  "add_innovations.unknown_list_plural_and_other": "y {{variable2}} otra",
  "add_innovations.unknown_list_plural_and_others": "y {{variable2}} otras",
  "add_innovations.unknown_list_plural": "Las referencias {{variable1}} no se han vendido o podrían ser incorrectos.",
  "add_innovations.unknown_list_singular": "La referencia {{variable}} no se tiene en cuenta ya que aún no se ha vendido o podría ser incorrecto.",
  "common_label.error_data": "-",
  "common_label.error_message": "Un error desconocido impidió que se cargara la página.",
  "delete_cta": "Borrar",
  "delete_toaster_info": "La innovación ha sido eliminada correctamente",
  "error_page.back_button": "Volver al Seguimiento de innovaciones",
  "error_page.generic_subtitle": "Esta página podría no existir, podría haber sido eliminada o es posible que no tenga los permisos necesarios. Si cree que se trata de un error, póngase en contacto con el administrador.",
  "error_page.generic_title": "No tiene acceso a esta página",
  "error_page.no_access_subtitle": "Si cree que se trata de un error, póngase en contacto con su administrador.",
  "error_page.no_access_title": "No tiene acceso al Seguimiento de Innovaciones",
  "inno_navbar.gitbook_button": "Contáctenos",
  "inno_navbar.gitbook_tooltip": "Acceso a la asistencia al usuario",
  "inno_navbar.module_name": "Seguimiento de innovaciones",
  "inno_navbar.title": "Carrefour Links",
  "inno_navbar.utilities": "Servicios",
  "inno_page_subtitle": "Maximice el rendimiento de sus innovaciones y adapte su estrategia",
  "inno_page_table_name": "Sus innovaciones",
  "inno_page_title": "Seguimiento de innovaciones",
  "inno_page.add_button": "Añadir vuestras innovaciones",
  "inno_page.date_selector_apply": "Aplicar selección",
  "inno_page.date_selector_end": "Fecha de fin",
  "inno_page.date_selector_start": "Fecha de inicio",
  "inno_page.date_selector_title": "Intervalo de tiempo para el análisis",
  "inno_page.export_button": "Exportar a csv",
  "inno_page.export_no_data_warning": "No hay datos disponibles para exportar",
  "inno_page.format_filters_all": "Todos",
  "inno_page.format_filters_format": "Formatos",
  "inno_page.supplier_filters_all": "Todos",
  "inno_page.supplier_filters": "Proveedores",
  "inno_reporting_email.cta_link": "Acceda a sus datos de rendimiento",
  "inno_reporting_email.period_reminder_from": "Desde",
  "inno_reporting_email.period_reminder_launch_date": "la fecha de lanzamiento",
  "inno_reporting_email.period_reminder_subtitle_previous": "a la semana anterior",
  "inno_reporting_email.period_reminder_subtitle": "Evolución con respecto",
  "inno_reporting_email.period_reminder_to": "hasta",
  "inno_reporting_email.table_column_detention": "Posesión sobre ventas",
  "inno_reporting_email.table_column_EAN": "Innovación",
  "inno_reporting_email.table_column_VMH": "Unidades medias semanales / Objetivo",
  "inno_reporting_email.table_title": "Sus innovaciones - Cambios con respecto a la semana pasada",
  "inno_reporting_email.title": "Reporting semanal de sus innovaciones",
  "inno_reporting_email.top_flop_detention.title": "Cambios más importantes de posesión con respecto a la semana pasada",
  "inno_reporting_email.top_flop_sales.subtitle": "Unidades medias semanales desde el lanzamiento",
  "inno_reporting_email.top_flop_sales.title": "Cambios más importantes en las ventas con respecto a la semana pasada (cantidad)",
  "inno_reporting_email.top_flop_since_last_week": "desde la semana pasada",
  "inno_topbar.logout_button": "Desconexión",
  "listing_table_column_name_ean": "EAN",
  "listing_table_column_name_format": "Formato",
  "listing_table_column_name_goal": "Progreso del objetivo",
  "listing_table_column_name_label": "Producto",
  "listing_table_column_name_launch_date": "Lanzamiento",
  "listing_table_column_name_posession_rate": "Tasa de posesión sobre ventas",
  "listing_table_column_name_product_name": "Producto",
  "listing_table_column_name_subfam_weekly_sales": "Unidades medias semanales (subfamilia)",
  "listing_table_column_name_supplier": "Proveedor",
  "listing_table_column_name_weekly_sales": "Unidades medias semanales",
  "monitoring_page.back_button": "Regrese a la lista de sus innovaciones",
  "monitoring_page.graph.copy_image_message": "Copiado al portapapeles",
  "monitoring_page.graph.copy_image": "Copiar la imagen",
  "monitoring_page.graph.extract_csv": "Exportar datos (csv)",
  "monitoring_page.graph.legend_innovation": "Unidades medias semanales",
  "monitoring_page.graph.legend_possesion_rate": "Tasa de posesión sobre ventas (%)",
  "monitoring_page.graph.legend_subclass": "Unidades medias semanales subfamilia",
  "monitoring_page.graph.save_image": "Exportar (PNG)",
  "monitoring_page.graph.title": "Rendimiento de la innovación",
  "monitoring_page.internal_search_field": "Buscar por EAN o nombre del producto",
  "monitoring_page.internal_search_no_result": "No hay resultados para",
  "monitoring_page.metadata_date_perimeter": "Del {{launchDate}} al {{today}}",
  "monitoring_page.metadata_launchdate": "Lanzado el",
  "monitoring_page.no_target_quantity": "Esta innovación no dispone de datos disponibles para el objetivo de unidades medias semanales.",
  "monitoring_page.not_shared_with_alert": "Solo Carrefour",
  "monitoring_page.objective_card_description": "Unidades medias semanales: {{averageWeeklySalesQuantity}}/{{averageWeeklySalesQuantityGoal}}",
  "monitoring_page.objective_card_title": "Ha alcanzado {{achieved_objective_percent}} de tu objetivo",
  "monitoring_page.shared_with_alert": "Compartido con {supplier_name}",
  "monitoring_page.store_detention_alert_export": "Extraer la lista de tiendas a CSV ({{store_count}})",
  "monitoring_page.store_detention_alert_plural": "tiendas deberían vender este artículo, pero no lo hacen.",
  "monitoring_page.store_detention_alert_singular": "tienda debería vender este artículo, pero no lo hace.",
  "monitoring_page.tab_name_quant": "Cantidad",
  "monitoring_page.tab_name_value": "Ventas con IVA",
  "monitoring_page.tabs.quant.left_side_objective": "Objectivo",
  "monitoring_page.tabs.quant.left_side_title": "Unidades medias semanales",
  "monitoring_page.tabs.quant.right_side_non_promo": "Sin promo",
  "monitoring_page.tabs.quant.right_side_promo": "En promo",
  "monitoring_page.tabs.quant.right_side_title": "Total desde el lanzamiento",
  "monitoring_page.tabs.value_right_side_title": "Total desde el lanzamiento (con IVA)",
  "monitoring_page.tabs.value.left_side_title": "Ventas medias semanales (con IVA)",
  "monitoring_page.tabs.value.right_side_non_promo": "En promo",
  "monitoring_page.tabs.value.right_side_promo": "Sin promo",
  "unsubscribe_page.cta_confirm": "Confirme y cancele la suscripción",
  "unsubscribe_page.main_subtext": "Puede volver a suscribirse en cualquier momento poniéndose en contacto con nuestro equipo de soporte.",
  "unsubscribe_page.main_text": "Está a punto de cancelar la suscripción al reporting semanal de innovaciones",
  "unsubscribe_page.question": "Una pregunta?",
  "unsubscribe_page.successful_text": "Su suscripción al reporting semanal de innovaciones ha sido cancelada",
  "unsubscribe_page.support": "Póngase en contacto con nuestro soporte"
}
